/* clarity.js — Thin wrapper around Microsoft Clarity custom tagging.
   The Clarity base script lives in /public/index.html (xd0jc704kb). This helper
   lets us attach custom dimensions to each session so we can filter sessions
   in the Clarity dashboard by funnel, language, lead status, etc.

   Silently no-ops if Clarity never loaded (adblockers, jsdom, GDPR-decline). */

const safeClarity = (...args) => {
  try {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      window.clarity(...args);
    }
  } catch {
    /* swallow — analytics must never crash the app */
  }
};

/** Set a custom tag visible in Clarity session filters.
 * Example: setTag("funnel", "v4-85pct") → filter sessions in Clarity by funnel=v4-85pct
 */
export const setTag = (key, value) => {
  if (value === undefined || value === null || value === "") return;
  safeClarity("set", String(key), String(value));
};

/** Fire a custom event marker — visible on the session-replay timeline.
 * Example: trackEvent("layer2_unlocked") → you see a labelled marker exactly
 * at the moment in the recording when Layer 2 became visible.
 */
export const trackEvent = (name) => safeClarity("event", String(name));

/** Identify a user once we know their email (post-submit). Use a hashed/
 * anonymised id rather than raw PII to stay GDPR-clean. */
export const identify = (userId, sessionId, pageId) =>
  safeClarity("identify", String(userId), sessionId, pageId);

/** Mark a session as high-priority so Clarity will prioritise storing it
 * (useful for known leads). */
export const upgrade = (reason) => safeClarity("upgrade", String(reason || "lead"));
